import React, { useEffect, useRef, useState } from 'react';
import Datepicker from '../../../../components/elements/form/datepicker';
import Teaxtarea from '../../../../components/elements/form/textarea';
import Loader from '../../../../components/loader';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import moment from 'moment';
import Button from '../../../../components/elements/button';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import SelectBox from '../../../../components/elements/form/selectBox';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { useReceiptApi } from '../../../../store/api/hooks/receiptApiHook';
import Currency from '../../../../components/currency';

interface ViewReceiptProps {
    PrID: number;
    onCreate?: () => void;
    onCancel?: () => void;
}

const ViewReceipt: React.FC<ViewReceiptProps> = ({ PrID, onCancel = () => { }, onCreate = () => { } }) => {
    const divRef = useRef<any>(null);

    const receiveStockApi: any = useReceiptApi();
    const commonApi: any = useCommonApi();

    const [showLoader, setShowLoader] = useState(false);
    const [lineItemMode, setLineItemMode] = useState('');
    const [lineItems, setLineItems] = useState<any[]>([]);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [attachments, setAttachments] = useState<any[]>([]);

    const [formData, setFormData] = useState({
        receiptCode: '',
        facilityName: '',
        requiredByDate: null as Date | null,
        purchaseOrderCode: '',
        notes: '',
        reason: '',
        requesterName: '',
        approvedBy: '',
        approvalDate: ``,
        receiptByName: '',
        addedDate: null as Date | null
    });

    const handleVendorSearch = async (inputval: any): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            commonApi.GetServiceprovidertList({}, (resp: any) => {
                if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
                    /*
                    const deptlist = resp.vendorList.map((user: any) => {
                        return {
                            label: user.name,
                            value: user.vendorID,
                        };
                    });
                    resolve(deptlist);
                    */
                    resolve(resp.vendorList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([])
            })
        });
    };

    const onOutsideClick = () => {
        handleOnClickCellEdit()
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}`) as HTMLDivElement;
            const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
            const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
            if (previewElement && editElement) {
                if (cellElement.id === `${identifier}`) {
                    if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                    if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                }
            }
        }

        //resetOthersCellEditState(`part-item-name-${index}`);
        const editableList = document.querySelectorAll(`.editable`) as NodeListOf<HTMLDivElement>
        //console.log("editableList", editableList);
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }

    };

    useEffect(() => {
        const init = async () => {
            if (!PrID) return;

            setShowLoader(true);
            const prdetails: any = await new Promise((resolve, reject) => {
                receiveStockApi.GetReciptByID({ ReciptID: PrID }, (resp: any) => {
                    if (resp) resolve(resp);
                    else reject('No PR found');
                }, reject);
            }).catch((e) => {
                setShowLoader(false);
                return null;
            });

            if (prdetails) {
                setFormData({
                    receiptCode: prdetails.receiptCode,
                    facilityName: prdetails.facilityName,
                    receiptByName: prdetails.receiptByName,
                    requiredByDate: moment.utc(prdetails.requiredByDate).local().toDate(),
                    addedDate: moment.utc(prdetails.addedDate).local().toDate(),
                    purchaseOrderCode: prdetails.purchaseOrderCode,
                    notes: prdetails.notes,
                    reason: prdetails.reason,
                    requesterName: prdetails.requesterName,
                    approvedBy: prdetails?.approvedBy || ``,
                    approvalDate: prdetails?.approvalDate ? moment.utc(prdetails.approvalDate).local().format(`MM/DD/YYYY`) : ``,
                });

                if (prdetails.receiptItemList?.length > 0) {
                    setLineItemMode('parts');
                    const items = prdetails.receiptItemList.map((o: any) => ({
                        partsID: o.partsID,
                        vendorPartCode: o.partsCode,
                        vendorPartName: o.partName,
                        vendorID: o.vendorID,
                        vendorName: o.vendorName,
                        requiredQty: o.requiredQty,
                        unitID: o.unitID,
                        unitPrice: (o.totalAmount / o.requiredQty) || 0,
                        unitName: o.unitCode,
                        totalAmount: o.totalAmount,
                        unitCost: o.unitCost ? o.unitCost.toFixed(2) : '0.00',
                        totalCost: o.totalCost ? o.totalCost.toFixed(2) : '0.00',
                        orderedQuantity: o.orderedQuantity || 0,
                        requiredQuantity: o.requiredQuantity || 0,
                    }));
                    setLineItems(items);
                }
                if (prdetails.receiptAssetList?.length > 0) {
                    setLineItemMode('assets');
                    const items = prdetails.receiptAssetList.map((o: any) => ({
                        assetName: o.assetName,
                        unitCost: o.unitCost ? o.unitCost.toFixed(2) : '0.00',
                        //unitPrice: (o.totalAmount / o.requiredQty) || 0,
                        unitPrice: (o.totalAmount / o.requiredQuantity) || 0,
                        unitName: o.unitCode,
                        orderedQuantity: o.orderedQuantity || 0,
                        //requiredQty: o.requiredQty,
                        requiredQuantity: o.requiredQuantity,
                        totalCost: o.totalCost ? o.totalCost.toFixed(2) : '0.00',
                    }));
                    setLineItems(items);
                }

                const attachments: any = await new Promise((resolve, reject) => {
                    receiveStockApi.GetReciptAttachments(
                        { receiptID: PrID },
                        (resp: any) => resolve(resp || []),
                        reject
                    );
                }).catch(() => []);


                setAttachments(attachments.files);
            }

            setShowLoader(false);
        };

        init();
    }, [PrID]);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClick]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClick();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClick]);

    const partsItems = lineItems;

    // Add this inside your component (ViewReceipt)
    const calculate_grandtotal = () => {
        if (lineItems && lineItems.length > 0) {
            return lineItems.reduce((total, item) => {
                const unitCost = parseFloat(item.unitCost) || 0;
                const requiredQuantity = parseFloat(item.requiredQuantity) || 0;
                return total + (unitCost * requiredQuantity);
            }, 0);
        }
        return 0;
    };


    return (
        <div className="flex flex-col h-full relative">
            {showLoader && (
                <div className="absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30">
                    <Loader />
                </div>
            )}

            {!showLoader && (
                <>
                    {/* Main Content */}
                    <div className="pt-4 flex-1">
                        <div className="bg-green-50 py-2 px-3">
                            <h6 className="text-[0.813rem] font-semibold">Receipt ID</h6>
                            <p className="text-[0.813rem] font-normal mt-2">{formData.receiptCode || '...'}</p>
                        </div>

                        <div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676] mr-2'>Selected PO</div>
                            <div className='text-[#323233]'>{formData.purchaseOrderCode}</div>
                        </div>

                        <div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676] mr-2'>Facility</div>
                            <div className='text-[#323233]'>{formData.facilityName || '-'}</div>
                        </div>

                        {lineItemMode === 'parts' && (
                            <div className="w-full">
                                <h4 className="font-semibold text-[0.938rem] py-4 uppercase">Line Items</h4>

                                {/* Horizontal scroll wrapper */}
                                <div className="w-full overflow-x-auto">
                                    <div className="min-w-full border border-[#043E6133] rounded-[5px] parts-table">
                                        {/* Table Header */}
                                        <div className="flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]">
                                            <div className="w-36 min-w-36 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">
                                                {/* sticky left-0 bg-[#F0F0F0] z-10 */} {/* Uncomment for sticky */}
                                                Part Code
                                            </div>
                                            <div className="w-60 min-w-60 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">
                                                Part Name
                                            </div>
                                            <div className="w-40 min-w-40 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">
                                                Vendor Part Code
                                            </div>
                                            <div className="w-30 min-w-30 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">
                                                Unit Cost
                                            </div>
                                            <div className="w-20 min-w-20 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Ordered Qty
                                            </div>
                                            <div className="w-20 min-w-20 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Delivered Qty
                                            </div>
                                            <div className="w-20 min-w-20 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Receiving Qty
                                            </div>
                                            <div className="w-20 min-w-20 font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Total Value
                                            </div>
                                        </div>

                                        {/* Table Body */}
                                        <div ref={divRef}>
                                            {lineItems.length === 0 && (
                                                <div className="flex items-center justify-center h-24 text-gray-500">
                                                    No parts added yet.
                                                </div>
                                            )}

                                            {lineItems.map((part, index) => (
                                                <div
                                                    key={index}
                                                    className={`flex items-center flex-nowrap ${index < lineItems.length - 1 ? 'border-b border-[#043E6133]' : ''
                                                        }`}
                                                >
                                                    <div className="w-36 min-w-36 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
                                                        {part.vendorPartCode || '--'}
                                                    </div>
                                                    <div className="w-60 min-w-60 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
                                                        {part.vendorPartName || '--'}
                                                    </div>
                                                    <div className="w-40 min-w-40 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
                                                        {part.vendorPartCode || '--'}
                                                    </div>
                                                    <div className="w-30 min-w-30 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 text-right flex items-center">
                                                        <Currency currency="USD" value={part.unitCost} />
                                                    </div>
                                                    <div className="w-20 min-w-20 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.orderedQuantity || 0}
                                                    </div>
                                                    <div className="w-20 min-w-20 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.deliveredQty || 0}
                                                    </div>
                                                    <div className="w-20 min-w-20 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.requiredQuantity || 0}
                                                    </div>
                                                    <div className="w-20 min-w-20 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 text-right flex items-center">
                                                        <Currency currency="USD" value={part.totalCost} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                        {lineItemMode === 'assets' && (
                            <div className="w-full">
                                <h4 className="font-semibold text-[0.938rem] py-4 uppercase">Line Items</h4>

                                {/* Horizontal scroll wrapper */}
                                <div className="w-full overflow-x-auto">
                                    <div className="min-w-full border border-[#043E6133] rounded-[5px] parts-table">

                                        {/* Table Header */}
                                        <div className="flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]">
                                            <div className="w-[240px] min-w-[240px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex items-center">
                                                Item Name
                                            </div>
                                            <div className="w-[120px] min-w-[120px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Unit Cost
                                            </div>
                                            <div className="w-[120px] min-w-[120px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Ordered Qty
                                            </div>
                                            <div className="w-[120px] min-w-[120px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Delivered Qty
                                            </div>
                                            <div className="w-[120px] min-w-[120px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Receiving Qty
                                            </div>
                                            <div className="w-[120px] min-w-[120px] font-semibold text-[#262A2D] text-[13px] px-2.5 py-2 h-[50px] flex justify-end items-center">
                                                Total Value
                                            </div>
                                        </div>

                                        {/* Table Body */}
                                        <div ref={divRef}>
                                            {lineItems.length === 0 && (
                                                <div className="flex items-center justify-center h-24 text-gray-500">
                                                    No parts added yet.
                                                </div>
                                            )}

                                            {lineItems.map((part, index) => (
                                                <div
                                                    key={index}
                                                    className={`flex items-center flex-nowrap ${index < lineItems.length - 1 ? 'border-b border-[#043E6133]' : ''
                                                        }`}
                                                >
                                                    <div className="w-[240px] min-w-[240px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center">
                                                        {part.assetName || '--'}
                                                    </div>
                                                    <div className="w-[120px] min-w-[120px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        <Currency currency="USD" value={part.unitCost} />
                                                    </div>

                                                    <div className="w-[120px] min-w-[120px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.orderedQuantity || 0}
                                                    </div>
                                                    <div className="w-[120px] min-w-[120px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.deliveredQty || 0}
                                                    </div>
                                                    <div className="w-[120px] min-w-[120px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        {part.requiredQuantity || 0}
                                                    </div>
                                                    <div className="w-[120px] min-w-[120px] font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-end items-center">
                                                        <Currency currency="USD" value={part.totalCost} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}



                        <div className="flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] border-b border-[#043E6133] text-[#262A2D]">
                            <div className="text-right">Grand Total</div>
                            <div className="w-28 text-right text-[#000000]">
                                <Currency currency={`USD`} value={calculate_grandtotal()} />
                            </div>
                        </div>

                        <div className="flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] border-b border-[#043E6133] text-[#262A2D]">
                            <div className="text-right">Received By</div>
                            <div className="w-28 text-right">{formData?.receiptByName || '-'}</div>
                        </div>

                        <div className="flex items-center justify-end gap-3 py-3 px-1 font-normal text-[15px] text-[#262A2D]">
                            <div className="text-right">Receiving Date</div>
                            <div className="w-28 text-right">
                                {formData?.addedDate ? moment(formData.addedDate).format('MM/DD/YY') : '-'}
                            </div>
                        </div>



                        <div className='flex py-6 border-b border-gray-200 items-center text-[0.938rem]'>
                            <div className='w-[12.5rem] text-[#767676] mr-2'>Notes</div>
                            <div className='text-[#323233]'>{formData.notes || '-'}</div>
                        </div>



                        {/* Attachments row */}
                        {attachments?.length > 0 && (
                            <div className='flex py-6 items-start text-[0.938rem]'>
                                <div className='w-[12.5rem] text-[#767676] mr-2'>Attachments</div>
                                <div className='flex flex-col gap-4 text-[#323233]'>
                                    {attachments.map((file: any) => {
                                        const ext = file.originalFileName?.split('.').pop()?.toLowerCase();
                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
                                        const isPDF = ext === 'pdf';

                                        return (
                                            <div key={file.receiptFileID} className="flex flex-col gap-1">
                                                <div className="font-medium">{file.originalFileName}</div>

                                                <a
                                                    href={file.fullFilePath}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="inline-block"
                                                >
                                                    {isImage ? (
                                                        <img
                                                            src={file.fullFilePath}
                                                            alt={file.originalFileName}
                                                            className="w-32 h-32 object-cover rounded-md border hover:opacity-80 transition"
                                                        />
                                                    ) : isPDF ? (
                                                        <div className="w-32 h-40 border rounded-md flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition">
                                                            <span className="text-sm text-blue-600">📄 PDF Preview</span>
                                                        </div>
                                                    ) : (
                                                        <div className="w-32 h-16 border rounded-md flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition">
                                                            <span className="text-sm text-blue-600">⬇ Download</span>
                                                        </div>
                                                    )}
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="bg-white px-4 py-3 border-t border-gray-300 z-10 flex justify-end fixed bottom-0 right-0 left-0">
                        <div className="flex justify-end items-center gap-1">
                            {(() => {

                                return (
                                    <>
                                        <Button theme="secondary" childstyle={{ padding: '4px 10px', fontSize: '0.75rem', lineHeight: '1rem' }} onClick={() => onCancel()}>Cancel</Button>
                                    </>
                                )

                            })()}
                        </div>
                    </div>
                </>
            )}
        </div>
    );

};

export default ViewReceipt;